import "./galeria.css";

export default function Galeria() {
  const images = [
    "/images/nutricion/nutricion2.webp",
    "/images/entrenamiento/entreno8.webp",
  ];

  return (
    <section className="galeria">
      <h2>"Tu cambio empieza con hábitos saludables."</h2>
      <div className="galeria-grid">
        {images.map((img, i) => (
          <div key={i} className="galeria-item">
            <img src={img} alt={`galeria-${i}`} />
          </div>
        ))}
      </div>
    </section>
  );
}
